// Module Federation bootstrap pattern
// This allows shared dependencies to be loaded before the app
import { retryDynamicImport } from 'utils/lazyRetry'

void retryDynamicImport(async () => import('./bootstrap'))
